export default {
  // ProviderVoicesEditor 音色管理
  'pages.providerVoicesEditor.msg.deleted': '已删除音色',
  'pages.providerVoicesEditor.msg.nameRequired': 'name 为必填项',
  'pages.providerVoicesEditor.msg.displayNameRequired': 'display_name 为必填项',
  'pages.providerVoicesEditor.msg.saveSuccess': '保存成功',
  'pages.providerVoicesEditor.msg.savedList': '已保存音色列表',
  'pages.providerVoicesEditor.msg.pastePrompt': '请粘贴 JSON 或 YAML 数组',
  'pages.providerVoicesEditor.msg.parseFailed': '解析失败，请检查 JSON/YAML 格式',
  'pages.providerVoicesEditor.msg.mustBeArray': '导入格式应为数组（JSON 或 YAML）',
  'pages.providerVoicesEditor.msg.importSuccess': '成功导入 {n} 条音色',
  'pages.providerVoicesEditor.msg.cleared': '已清空音色列表',
  'pages.providerVoicesEditor.msg.previewNeedProvider': '请先选择 TTS 类型后再试听',
  'pages.providerVoicesEditor.msg.previewGenerateFail': '生成失败，请稍后重试',
  'pages.providerVoicesEditor.msg.previewGenerating': '正在生成试听音频…',
  'pages.providerVoicesEditor.drawer.title': '管理音色',
  'pages.providerVoicesEditor.btn.importJson': '导入 JSON/YAML',
  'pages.providerVoicesEditor.btn.clear': '清空',
  'pages.providerVoicesEditor.btn.saveClose': '保存并关闭',
  'pages.providerVoicesEditor.btn.add': '新增音色',
  'pages.providerVoicesEditor.btn.pasteImport': '粘贴导入 (JSON/YAML)',
  'pages.providerVoicesEditor.btn.preview': '试听',
  'pages.providerVoicesEditor.btn.batchGenerate': '批量生成',
  'pages.providerVoicesEditor.btn.batchCancel': '取消生成',
  'pages.providerVoicesEditor.btn.edit': '编辑',
  'pages.providerVoicesEditor.btn.delete': '删除',
  'pages.providerVoicesEditor.batch.confirmTitle': '批量生成试听音频',
  'pages.providerVoicesEditor.batch.confirmContent':
    '将为本供应商中尚未生成试听音频的音色一次性合成（当前列表约 {n} 条缺失）。任务在后台执行，可在此查看进度。',
  'pages.providerVoicesEditor.batch.progress': '批量生成进度',
  'pages.providerVoicesEditor.batch.stats':
    '进度 {done}/{total}，生成 {generated}，跳过 {skipped}，失败 {failed}',
  'pages.providerVoicesEditor.batch.current': '当前',
  'pages.providerVoicesEditor.msg.batchRunning': '批量生成正在进行中',
  'pages.providerVoicesEditor.msg.batchNothing': '没有需要生成的音色（均已有试听音频）',
  'pages.providerVoicesEditor.msg.batchStartFail': '启动批量生成失败',
  'pages.providerVoicesEditor.msg.batchCancelFail': '取消失败',
  'pages.providerVoicesEditor.msg.batchCancelled': '批量生成已取消',
  'pages.providerVoicesEditor.msg.batchPartialFail': '批量生成完成：成功 {ok}，失败 {fail}',
  'pages.providerVoicesEditor.msg.batchDone': '批量生成完成：生成 {ok}，跳过 {skip}',
  'pages.providerVoicesEditor.list.language': '语种',
  'pages.providerVoicesEditor.list.mandarin': '普通话',
  'pages.providerVoicesEditor.modal.editTitle': '编辑音色',
  'pages.providerVoicesEditor.modal.addTitle': '新增音色',
  'pages.providerVoicesEditor.label.voiceId': '音色id *',
  'pages.providerVoicesEditor.label.displayName': '显示名字 *',
  'pages.providerVoicesEditor.label.sex': '性别',
  'pages.providerVoicesEditor.label.description': '描述',
  'pages.providerVoicesEditor.label.audioUrl': '试听音频链接',
  'pages.providerVoicesEditor.label.language': '语言',
  'pages.providerVoicesEditor.placeholder.language': '如 普通话、英语、粤语、日语',
  'pages.providerVoicesEditor.import.title': '导入 JSON/YAML 数组',
  'pages.providerVoicesEditor.import.appendOk': '追加导入',
  'pages.providerVoicesEditor.import.replaceAll': '替换全部并导入',
  'pages.providerVoicesEditor.import.loadSample': '加载示例',
  'pages.providerVoicesEditor.import.placeholder': '请粘贴 JSON 或 YAML 数组，格式示例可通过“加载示例”按钮插入',

  // LogViewer 日志查看
  'pages.admin.ops.logViewer.fetchFailed': '获取日志列表失败',
  'pages.admin.ops.logViewer.downloadFailed': '下载失败',
  'pages.admin.ops.logViewer.previewFailed': '预览失败',
  'pages.admin.ops.logViewer.columnName': '文件名',
  'pages.admin.ops.logViewer.columnSize': '大小 (字节)',
  'pages.admin.ops.logViewer.columnMtime': '修改时间',
  'pages.admin.ops.logViewer.columnAction': '操作',
  'pages.admin.ops.logViewer.download': '下载',
  'pages.admin.ops.logViewer.refresh': '刷新',

  // OssMediaUpload OSS 媒体上传
  'pages.ossMediaUpload.sizeExceed': '文件大小不能超过 {n}MB',
  'pages.ossMediaUpload.formatOnly': '仅支持格式：{formats}',
  'pages.ossMediaUpload.selectImage': '请选择图片文件',
  'pages.ossMediaUpload.selectVideo': '请选择视频文件',
  'pages.ossMediaUpload.uploadSuccess': '上传成功',
  'pages.ossMediaUpload.uploadFailed': '上传失败',
  'pages.ossMediaUpload.dragText': '点击或拖拽文件到此上传',
  'pages.ossMediaUpload.dragHint': '将保存到 OSS，提交表单时请保存',
  'pages.ossMediaUpload.uploadedFile': '已上传文件',

  // LLMProvider 供应商配置
  'pages.admin.providerModal.coze.token.placeholder': '请输入 Coze Token',
  'pages.admin.providerModal.coze.botid.placeholder': '请输入 Coze Bot ID',
  'pages.admin.providerModal.coze.userid.placeholder': '可选：Coze User ID',
  'pages.admin.providerModal.coze.botid.required': '请输入 Bot ID',
  'pages.admin.providerModal.commercialLicenseOnly': '仅允许商业授权设备使用（需商业版智能体）',

  // VLLLMProvider 安全配置
  'pages.admin.providerModal.security.maxFileSize': '最大文件大小 (字节)',
  'pages.admin.providerModal.security.maxPixels': '最大像素数',
  'pages.admin.providerModal.security.maxWidth': '最大宽度',
  'pages.admin.providerModal.security.maxHeight': '最大高度',
  'pages.admin.providerModal.security.allowedFormats': '允许的格式',

  // ProviderCard 供应商卡片
  'pages.admin.providerCard.config.presetModel': '预设模型',
  'pages.admin.providerCard.config.cloneModel': '克隆合成模型',

  // TTSProvider 克隆音色
  'pages.admin.providerModal.voiceCloneModel.label': '克隆音色合成模型',
  'pages.admin.providerModal.voiceCloneModel.hint': '预设音色使用上方模型；克隆音色合成时使用此 VC 模型，须与克隆 API 的 target_model 一致',
  'pages.admin.providerModal.voiceCloneModel.hintCosyvoice': '须与上方合成模型一致（如 cosyvoice-v3-flash）；留空则自动使用上方模型',

  // Footer 页脚
  'pages.footer.copyright': '© 赛搏 Ai',

  // KnowledgeBaseRecallTestModal 召回测试
  'pages.knowledgeBase.recall.resultFallback': '结果',

  // CancelAccount 注销账号
  'cancelAccount.warning1': '账号注销后，您的所有个人信息、设备绑定记录及使用数据将被永久删除。',
  'cancelAccount.warning2': '注销操作不可逆转，无法恢复已删除的任何数据。',
  'cancelAccount.warning3': '绑定的设备将自动解绑，可能影响设备的正常使用。',
  'cancelAccount.warning4': '如有未消耗的余额或权益，将自动作废且无法退还。',
  'cancelAccount.pleaseEnterEmail': '请输入您的账号邮箱',
  'cancelAccount.invalidEmail': '请输入格式正确的邮箱地址',
  'cancelAccount.confirmDialogTitle': '确认申请注销账号？',
  'cancelAccount.confirmDialogDesc': '请仔细阅读上方风险提示。点击确认将生成注销邮件。',
  'cancelAccount.accountLabel': '账号：',
  'cancelAccount.confirmDialogConfirm': '确认申请',
  'cancelAccount.confirmDialogCancel': '取消',
  'cancelAccount.emailSubject': '【账号注销申请】',
  'cancelAccount.emailBody': '您好，我需要申请注销以下账号：',
  'cancelAccount.emailAccountLabel': '注销账号：',
  'cancelAccount.emailReasonLabel': '注销原因：',
  'cancelAccount.successDialogTitle': '注销申请邮件已生成',
  'cancelAccount.successDialogDesc': '若您的设备未能自动跳转到邮件客户端，请手动复制下方客服邮箱，并发送您的注销申请。',
  'cancelAccount.successDialogNote': '我们将在收到邮件后的 7 个工作日内为您处理。',
  'cancelAccount.copySuccess': '邮箱已复制',
  'cancelAccount.copy': '复制',
  'cancelAccount.gotIt': '好的',
  'cancelAccount.headerTitle': '注销账号',
  'cancelAccount.headerSubtitle': '注销后将永久删除所有数据且不可恢复，请谨慎操作。',
  'cancelAccount.warningTitle': '注销账号风险提示',
  'cancelAccount.emailSectionTitle': '确认账号信息',
  'cancelAccount.emailSectionDesc': '请输入需要注销的账号邮箱',
  'cancelAccount.emailPlaceholder': '请输入账号邮箱',
  'cancelAccount.reasonTitle': '注销原因',
  'cancelAccount.optional': '(选填)',
  'cancelAccount.reasonPlaceholder': '请告诉我们您注销的原因，帮助我们改进服务...',
  'cancelAccount.submitButton': '提交注销申请',

  // ASRProvider 中文/小语种断句
  'pages.admin.providerModal.bidirectionalSilence.title': '中文断句（高级）',
  'pages.admin.providerModal.bidirectionalSilence.hint':
    '双向流式（中文等）判停：此处为「正常档」基准毫秒，智能体识别速度在其上缩放（耐心×2 / 正常×1 / 快速×0.75）。默认 500（即 1000/500/375）。仍易打断可再调到 700~800，或把智能体识别速度设为「耐心」。',
  'pages.admin.providerModal.bidirectionalSilence.finalize':
    '本地静默判停 silence_finalize_ms (ms)',
  'pages.admin.providerModal.bidirectionalSilence.endWindow':
    '服务端判停窗口 end_window_size (ms)',
  'pages.admin.providerModal.ladder.title': '阶梯式延长聆听（高级）',
  'pages.admin.providerModal.ladder.hint':
    '仅对豆包（双向流式，中文/英文/粤语）生效，其他 ASR 判停在服务端、配置无效。开启后：句尾像半截句（如「你觉得就」「等等」）时不再一次性加时，改按 100/200/300/400/500ms 五段递进续听；延长期内检出持续人声或单字填充词会重置计时（最多 2 次、总上限 2500ms），说完的句子更快结束、没说完的持续续听。保存后下一句话生效，无需重启。细分参数（分段/额度/能量阈值）可在供应商配置 JSON 中补 incomplete_ladder_* 键。',
  'pages.admin.providerModal.ladder.enable': '启用阶梯式延长聆听',
  'pages.admin.providerModal.nostreamSilence.title': '小语种断句（高级）',
  'pages.admin.providerModal.nostreamSilence.hint':
    '小语种（如俄语）静默判停毫秒：值越大整句越完整、值越小响应越快。留空用默认 450/600/750。档位由智能体 asrSpeed 决定走哪一档（1 耐心 / 2 正常 / 3 快速）',
  'pages.admin.providerModal.nostreamSilence.fast': '静默判停·快速档 (ms)',
  'pages.admin.providerModal.nostreamSilence.normal': '静默判停·正常档 (ms)',
  'pages.admin.providerModal.nostreamSilence.slow': '静默判停·耐心档 (ms)',

  // 麦克风权限错误
  'helpers.media.unsupportedEnv': '当前环境不支持访问麦克风',
  'helpers.media.insecureContext':
    '麦克风需在安全环境（HTTPS 或 localhost）下使用；当前页面地址不安全，无法调用麦克风。',
  'helpers.media.browserUnsupported':
    '当前浏览器不支持麦克风访问，请使用最新 Microsoft Edge 或 Google Chrome。',

  // Register / ForgotPassword 短信发送
  'pages.register.smsCode.sendFailed': '发送失败',
  'pages.forgotPassword.smsCode.sendFailed': '发送失败',

  // Welcome 欢迎页
  'pages.welcome.greetingLine': '{greeting}，{name}',
};
